"use strict";

exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/util/hyphenate.js
// module id = 641
// module chunks = 0